import { Button } from '@sendible/design-system/src';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { MediaType, PostType, composeTabs } from '@sendible/shared-state-bridge';
import { Feedback, Container, Row, Group } from './index.styles';
import { useGetValidationForMedia } from './useGetValidationForMedia';
interface Props {
  media: MediaType;
  tabId: composeTabs;
  postType: PostType;
}

export const MediaValidations = ({ media, tabId, postType }: Props) => {
  const [current, setCurrent] = useState(0);
  const { getValidationForMedia } = useGetValidationForMedia();
  const validationsForMedia = getValidationForMedia(media, tabId, postType);
  const { t } = useTranslation('common_terms');

  return validationsForMedia ? (
    <Container
      data-testid="media-validation-container"
      $type={validationsForMedia[current].type}
    >
      {validationsForMedia?.length > 1 && (
        <Row>
          <Group>
            <Button
              data-testid="media-validation-button-left"
              disabled={current === 0}
              icon="arrow_left"
              onClick={() => setCurrent((prev) => prev - 1)}
              type="button"
              variation="outline"
            />
            <Button
              data-testid="media-validation-button-right"
              disabled={current === validationsForMedia.length - 1}
              icon="arrow_right"
              onClick={() => setCurrent((prev) => prev + 1)}
              type="button"
              variation="outline"
            />
          </Group>
          <p data-testid="media-validation-page-indicator">{`${current + 1} ${t('of')} ${validationsForMedia.length}`}</p>
        </Row>
      )}
      <Feedback
        data-testid="media-validation-feedback"
        dangerouslySetInnerHTML={{ __html: validationsForMedia[current].message }}
      />
    </Container>
  ) : null;
};
